export const GREENSCREENS_PARTNERSHIP_LINK = "https://brokers.greenscreens.ai/partnership/portex";
